
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ASSETS } from '../../constants';

export const PageTransition: React.FC = () => {
  const location = useLocation();
  const [isActive, setIsActive] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    // Attiva l'animazione al cambio di rotta
    setShouldRender(true);
    setIsActive(true);

    // Timer per rimuovere il componente dal DOM dopo che l'animazione fade-out è completata
    const timer = setTimeout(() => {
      setIsActive(false);
      setTimeout(() => setShouldRender(false), 100);
    }, 1200);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (!shouldRender) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center bg-[#050508] pointer-events-none
        ${isActive ? 'animate-overlay-fade' : 'hidden'}
      `}
    >
      <div className="flex flex-col items-center justify-center animate-logo-reveal">
        {/* Container principale per centratura matematica */}
        <div className="relative w-64 h-64 flex items-center justify-center">

          {/* Glow Effect Background - Pulsing in Sync */}
          <div className="absolute inset-0 bg-blue-500/10 blur-[60px] rounded-full transform scale-125 animate-pulse-sync"></div>

          {/* Rings Container - Absolute & Centered */}
          {/* Outer Ring - Orange - Clockwise */}
          <div className="absolute inset-0 rounded-full border-t-2 border-r-2 border-orange-500/80 animate-spin-sync"></div>

          {/* Inner Ring - Blue - Counter-Clockwise (Reverse) */}
          <div className="absolute inset-4 rounded-full border-b-2 border-l-2 border-blue-500/80 animate-spin-reverse-sync"></div>

          {/* Logo Image - Centered Absolute & Pulsing Sync */}
          <div className="absolute inset-0 flex items-center justify-center z-10">
            <img
              src={ASSETS.LOGO_COMPANY}
              alt="ChartTower Loading"
              className="w-48 h-48 object-contain animate-pulse-sync drop-shadow-2xl"
            />
          </div>
        </div>

        {/* Text */}
        <h2 className="mt-8 text-2xl font-black tracking-widest text-white uppercase relative z-10 text-center">
          Chart<span className="text-orange-500">Tower</span>
        </h2>
      </div>
    </div>
  );
};
